/* eslint-disable */
import React, { useEffect, useRef } from 'react';
import { useDataContext } from '../context';

const API_URL = import.meta.env.VITE_API_URL;

function GetJobOpeningAll() { // เปลี่ยนชื่อจาก AllDepartment เป็น GetJobOpeningAll
  const { data, setData } = useDataContext();
  
  // ตัวกันยิงซ้ำ
  const hasFetched = useRef(false);

  useEffect(() => {
    // 1. เช็คว่ามีข้อมูลใน Context หรือยัง? (ถ้ามีแล้ว ไม่ต้องโหลด)
    if (data.getJobOpeningAll && data.getJobOpeningAll.length > 0) {
        return;
    }

    // 2. เช็คว่าเคยยิงไปแล้วหรือยัง (Strict Mode Protection)
    if (hasFetched.current) return;

    const fetchData = async () => {
      hasFetched.current = true;
      try {
        const requestOptions = {
          method: "GET",
          redirect: "follow"
        };
        
        const response = await fetch(`${API_URL}/getJobOpeningAll`, requestOptions);
        const result = await response.json();

        setData(prevData => ({
            ...prevData, 
            getJobOpeningAll: result.data || []
        }));

      } catch (error) {
        console.error("Error fetching job openings:", error);
        hasFetched.current = false; // Reset on error
      }
    };

    fetchData();
    
  }, []); // Run once on mount

  return null;
}

export default GetJobOpeningAll;